'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Publikationsupload = require('../entity').Publikationsupload;

module.exports = function (connection) {
  return {
    byDateiUploadEquals: function byDateiUploadEquals(dateiupload, additionalParams) {
      return templates.searchTemplate(connection)(Publikationsupload, 'byDateiUploadEquals', 'dateiupload')(dateiupload, additionalParams);
    },
    byOptionalCommentEquals: function byOptionalCommentEquals(optionalcomment, additionalParams) {
      return templates.searchTemplate(connection)(Publikationsupload, 'byOptionalCommentEquals', 'optionalcomment')(optionalcomment, additionalParams);
    },
    byOptionalCommentLike: function byOptionalCommentLike(optionalcomment, additionalParams) {
      return templates.searchTemplate(connection)(Publikationsupload, 'byOptionalCommentLike', 'optionalcomment')(optionalcomment, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Publikationsupload, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Publikationsupload, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Publikationsupload, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('publikationsupload')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/publikationsupload.js
// module id = vh7c
// module chunks = 0